import { render } from "./PurchaseSuppliers.vue?vue&type=template&id=15152957&scoped=true&ts=true&lang=pug"
import script from "./PurchaseSuppliers.vue?vue&type=script&lang=ts"
export * from "./PurchaseSuppliers.vue?vue&type=script&lang=ts"

import "./PurchaseSuppliers.vue?vue&type=style&index=0&id=15152957&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15152957"]])

export default __exports__